'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface VideoTutorialCardProps {
  title: string;
  description: string;
  thumbnail: string;
  alt: string;
  duration: string;
  views: number;
  category: string;
}

const VideoTutorialCard = ({
  title,
  description,
  thumbnail,
  alt,
  duration,
  views,
  category,
}: VideoTutorialCardProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
    console.log(`Playing video: ${title}`);
  };

  return (
    <div className="bg-card rounded-lg shadow-soft hover:shadow-elevated transition-all duration-base overflow-hidden">
      <div className="relative h-56 overflow-hidden group cursor-pointer" onClick={handlePlay}>
        <AppImage
          src={thumbnail}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-base"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors duration-base">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-base">
            <Icon name="PlayIcon" size={32} variant="solid" className="text-primary ml-1" />
          </div>
        </div>
        <div className="absolute top-4 right-4 bg-black/70 text-white px-2 py-1 rounded text-xs font-semibold">
          {duration}
        </div>
        <div className="absolute bottom-4 left-4">
          <span className="inline-block bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-semibold">
            {category}
          </span>
        </div>
      </div>

      <div className="p-6">
        <h3 className="text-lg font-headline font-bold text-text-primary mb-2 line-clamp-2">
          {title}
        </h3>
        <p className="text-text-secondary text-sm mb-4 line-clamp-2">{description}</p>

        <div className="flex items-center justify-between text-xs text-text-secondary">
          <span className="flex items-center space-x-1">
            <Icon name="EyeIcon" size={16} variant="outline" />
            <span>{views.toLocaleString()} views</span>
          </span>
          <button
            onClick={handlePlay}
            className="flex items-center space-x-1 text-primary hover:text-secondary transition-colors duration-base font-semibold"
          >
            <span>Watch Now</span>
            <Icon name="ArrowRightIcon" size={16} variant="outline" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoTutorialCard;